import React, { Component } from 'react'
import { BillingAddress } from '../../../../../components/form-components'
import StyledStepFrom from './styled-step-from.component'

class BillingAddressStep extends Component {
	submit = () => this.props.onSubmit(this.props.addresses)

	render() {
		const { onAdvance, clientId } = this.props
		return (
			<StyledStepFrom>
				<BillingAddress clientId={clientId} onAdvance={onAdvance} />
			</StyledStepFrom>
		)
	}
}

export default BillingAddressStep
